/* Crochuito – studio: header (tabs, floating bar, sliding pill, menu, language), cart count,
   smooth in-page links, scroll-linked panels and the hero's pointer depth. */
(function () {
  'use strict';
  if (window.CSStudio) return;
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var R = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* =========================================================
     Header: docked tabs at the top, a floating bar after scrolling
     ========================================================= */
  var hd = d.querySelector('[data-st-hd]');
  var FLOAT_ON = 150, FLOAT_OFF = 24;
  var floatOn = false, shown = false, lastY = w.scrollY, menuOpen = false;

  function setShown(on) {
    if (!hd || on === shown) return;
    shown = on;
    hd.classList.toggle('is-shown', on);
    de.classList.toggle('st-hd-on', on);
  }
  function setFloat(on) {
    if (!hd || on === floatOn) return;
    floatOn = on;
    hd.classList.add('is-snap');
    hd.classList.toggle('is-float', on);
    if (!on) setShown(false);
    requestAnimationFrame(function () { requestAnimationFrame(function () { hd.classList.remove('is-snap'); restPill(); }); });
  }
  if (hd) hd.addEventListener('focusin', function () { if (floatOn) setShown(true); });
  function headerTick(y) {
    if (!hd) return;
    var dy = y - lastY;
    lastY = y;
    if (menuOpen) return;
    if (!floatOn && y > FLOAT_ON) setFloat(true);
    else if (floatOn && y < FLOAT_OFF) setFloat(false);
    if (!floatOn) return;
    if (dy < -3) setShown(true);
    else if (dy > 4 && !hd.contains(d.activeElement)) setShown(false);
  }

  /* ---------- sliding pill under the navigation ---------- */
  var nav = hd && hd.querySelector('[data-st-nav]');
  var pill = hd && hd.querySelector('[data-st-pill]');
  var hovering = null;
  function placePill(a) {
    if (!pill) return;
    if (!a) { pill.classList.remove('is-on'); return; }
    var box = pill.parentNode.getBoundingClientRect(), r = a.getBoundingClientRect();
    if (!r.width) return;
    pill.style.width = r.width + 'px';
    pill.style.transform = 'translateX(' + (r.left - box.left) + 'px)';
    pill.classList.add('is-on');
  }
  function restPill() {
    if (!nav || hovering) return;
    placePill(nav.querySelector('a[aria-current]'));
  }
  if (nav && pill) {
    hd.classList.add('is-js');
    $$('a', nav).forEach(function (a) {
      a.addEventListener('mouseenter', function () { hovering = a; placePill(a); });
      a.addEventListener('focus', function () { hovering = a; placePill(a); });
      a.addEventListener('blur', function () { hovering = null; restPill(); });
    });
    nav.addEventListener('mouseleave', function () { hovering = null; restPill(); });
    pill.classList.add('is-instant');
    restPill();
    requestAnimationFrame(function () { requestAnimationFrame(function () { pill.classList.remove('is-instant'); }); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { pill.classList.add('is-instant'); restPill(); requestAnimationFrame(function () { pill.classList.remove('is-instant'); }); });
  }

  /* ---------- menu on small screens ---------- */
  var menu = d.querySelector('[data-st-menu]');
  var menuBtn = hd && hd.querySelector('[data-st-menu-open]');
  var menuT = 0;
  function openMenu() {
    if (!menu || menuOpen) return;
    menuOpen = true;
    clearTimeout(menuT);
    if (typeof menu.showModal === 'function') { if (!menu.open) menu.showModal(); } else menu.setAttribute('open', '');
    de.classList.add('st-menu-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add('is-open'); }); });
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMenu(keepFocus) {
    if (!menu || !menuOpen) return;
    menuOpen = false;
    menu.classList.remove('is-open');
    de.classList.remove('st-menu-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    clearTimeout(menuT);
    menuT = setTimeout(function () {
      if (menu.open && typeof menu.close === 'function') menu.close(); else menu.removeAttribute('open');
      if (!keepFocus && menuBtn) menuBtn.focus({ preventScroll: true });
    }, reduce ? 0 : 380);
  }
  if (menu) {
    menu.addEventListener('cancel', function (e) { e.preventDefault(); closeMenu(); });
    menu.addEventListener('click', function (e) {
      if (e.target === menu || (e.target.closest && e.target.closest('[data-st-menu-close]'))) { e.preventDefault(); closeMenu(); }
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-st-menu-open]');
    if (b) { e.preventDefault(); openMenu(); }
  });
  w.addEventListener('pageshow', function (e) { if (e.persisted && menuOpen) closeMenu(true); });

  /* ---------- language choice ---------- */
  $$('[data-st-lang]').forEach(function (det) {
    d.addEventListener('click', function (e) { if (det.open && !det.contains(e.target)) det.open = false; });
    det.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && det.open) { det.open = false; var s = det.querySelector('summary'); if (s) s.focus(); }
    });
  });

  /* ---------- cart count ---------- */
  function setCount(n) {
    $$('[data-st-count]').forEach(function (el) {
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      el.hidden = !n;
      if (n > prev && !reduce) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  d.addEventListener('cart:update', function (e) {
    var det = e.detail || {}, c = det.resource;
    var n = c && typeof c.item_count === 'number' ? c.item_count : (det.data && typeof det.data.itemCount === 'number' ? det.data.itemCount : null);
    if (n !== null) { setCount(n); return; }
    fetch(R + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  });

  /* =========================================================
     Smooth in-page links (such as Learn more in the hero)
     ========================================================= */
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (!url.hash || url.hash.length < 2) return;
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return;
    var t = d.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!t) return;
    e.preventDefault();
    if (menuOpen) closeMenu(true);
    var top = t.getBoundingClientRect().top + w.scrollY - 12;
    w.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', url.hash);
  });

  /* =========================================================
     Scroll-linked panels: the hero eases back, panels settle in
     ========================================================= */
  var exits = [], enters = [], ticking = false, vh = w.innerHeight;
  var ENTER = '.cs-make, .cs-anat, .cs-teaser, .cs-related, .cs-finale__media, .cs-voices';
  function collect() {
    exits = $$('[data-st-exit]');
    enters = reduce ? [] : $$(ENTER).filter(function (el) { return !el.closest('.st-hero'); });
    enters.forEach(function (el) { el.classList.add('st-enter'); });
  }
  function frame() {
    ticking = false;
    var y = w.scrollY;
    headerTick(y);
    if (reduce) return;
    exits.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -40 || r.top > vh) return;
      el.style.setProperty('--st-x', clamp(-r.top / Math.max(1, r.height), 0, 1).toFixed(4));
    });
    enters.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = clamp((vh - r.top) / (vh * 0.6), 0, 1);
      if (p >= 1) { if (!el.classList.contains('is-in')) { el.classList.add('is-in'); el.style.removeProperty('--st-in'); } return; }
      el.classList.remove('is-in');
      el.style.setProperty('--st-in', p.toFixed(4));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', function () { vh = w.innerHeight; restPill(); onScroll(); });

  /* =========================================================
     Hero: the photo answers the pointer with a little depth
     ========================================================= */
  function initHeroDepth() {
    if (reduce || !fine) return;
    $$('[data-st-hero]').forEach(function (hero) {
      var panel = hero.querySelector('.st-hero__panel');
      if (!panel || panel._depth) return;
      panel._depth = 1;
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
      function loop() {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        panel.style.setProperty('--mx', cx.toFixed(4));
        panel.style.setProperty('--my', cy.toFixed(4));
        raf = (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) ? requestAnimationFrame(loop) : 0;
      }
      panel.addEventListener('pointermove', function (e) {
        var r = panel.getBoundingClientRect();
        tx = clamp((e.clientX - r.left) / r.width * 2 - 1, -1, 1);
        ty = clamp((e.clientY - r.top) / r.height * 2 - 1, -1, 1);
        if (!raf) raf = requestAnimationFrame(loop);
      });
      panel.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
    });
  }

  function init() {
    collect();
    initHeroDepth();
    frame();
    if (de.classList.contains('cs-has-intro')) {
      setTimeout(function () { $$('[data-st-hero]').forEach(function (h) { h.classList.add('is-live'); }); }, 2600);
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function () { collect(); initHeroDepth(); onScroll(); });

  w.CSStudio = { openMenu: openMenu, closeMenu: closeMenu, refresh: function () { collect(); onScroll(); } };
})();
